import * as types from '../types'
import { RouterMenuList } from '@/router/menulist'
import { RouteDefines } from '@/utils/defines'

const filterMenus = function(menuIDS) {
  const newMainRouters = [];
  let indexRoute = {}
  let hasIndexRoute = false
  for (var i in RouterMenuList) {
    const menu = RouterMenuList[i];
    if (menu.name === RouteDefines.ROUTER_NAME_HOME) {
      indexRoute = menu;
    }
    if (menu.meta && menu.meta.hidden) {
      newMainRouters.push(menu);
      continue;
    }
    let firstChildren = [];
    const secondChildren = [];
    for (var j in menu.children) {
      if (menu.children[j].meta.level > 2) {
        secondChildren.push(menu.children[j])
      } else if (menuIDS.indexOf(menu.children[j].meta.menu_id) > -1) {
        firstChildren.push(menu.children[j]);
      }
    }
    // 如果二级菜单没有权限，那么他下面的路由都不可以访问
    const newSecondChild = secondChildren.filter(second => {
      for (i in firstChildren) {
        const first = firstChildren[i]
        if (first.name === second.meta.parent_name) {
          return true;
        }
      }
      return false;
    })
    firstChildren = firstChildren.concat(newSecondChild)
    if (firstChildren.length > 0) {
      menu.children = firstChildren;
      menu.redirect = firstChildren[0].path
      newMainRouters.push(menu);
      if (menu.name === RouteDefines.ROUTER_NAME_HOME) {
        hasIndexRoute = true;
      }
    }
  }
  // 如果没有首页的权限，首页的跳转路径改为其他二级菜单地址
  if (!hasIndexRoute) {
    indexRoute.redirect = newMainRouters[0]['children'][0].path
    indexRoute.meta.hidden = true;
    indexRoute.children = [];
    newMainRouters.unshift(indexRoute);
  }
  return newMainRouters;
}

export default {
  state: {
    role: 0,
    menus: []
  },
  mutations: {
    [types.SET_MENU_PERMISSIONS]: (state, { routes }) => {
      state.menus = routes.slice()
    },
    [types.SET_ROLE]: (state, role) => {
      state.role = role
    }
  },
  actions: {
    /**
    /**
     * 过滤操作员的菜单权限
     */
    SetPermissions: ({ commit }, { menuIDS, role }) => {
      return new Promise(resolve => {
        const newMainRouters = filterMenus(menuIDS)
        commit(types.SET_ROLE, role)
        commit(types.SET_MENU_PERMISSIONS, { routes: newMainRouters })
        resolve();
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js